import React from "react";
import { ServiceCard } from "../../types";
import "./Services.css";

const Services: React.FC = () => {
  const serviceCards: ServiceCard[] = [
    {
      id: 1,
      tags: ["기억력 활성화", "언어 능력 향상", "인지 기능 개선"],
      title: "기억이 되살아나는 순간",
      description:
        "기억 회상과 언어 처리 능력을 활용하여 인지 기능 감소를 늦추고 더 선명한 일상을 선물합니다.",
    },
    {
      id: 2,
      tags: ["정서적 안정감", "우울감 완화", "내면의 평화"],
      title: "마음이 평안해지는 시간",
      description:
        "삶을 되돌아보는 과정에서 정서적 안정과 우울감 완화를 완화하고, 진정한 내면의 평화를 찾습니다.",
    },
    {
      id: 3,
      tags: ["활발한 소통", "세대 간 이해", "따뜻한 가정"],
      title: "가족과 더 가까워지는 마법",
      description:
        "가족과 미래 세대와 공유하며, 세대 간 이해의 다리가 되어 따뜻한 소통의 장을 만듭니다.",
    },
    {
      id: 4,
      tags: ["지혜의 전수", "영원한 기록", "사랑의 선물"],
      title: "영원히 남을 소중한 선물",
      description:
        "개인의 지혜와 경험을 체계적으로 정리하여 다음 세대에게 전하는 가장 특별한 방법입니다.",
    },
  ];

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <div className="section-header">
          <div className="section-meta section-meta--orange">스토리북 효과</div>
          <h2 className="section-title">
            기억의 서랍이 선사하는 4가지 특별한 변화
          </h2>
          <p className="section-subtitle">
            <br />
            단순한 책 만들기를 넘어, 당신의 인생에 일어날 아름다운 변화들
          </p>
        </div>
        <div className="services-grid">
          {serviceCards.map((card) => (
            <div key={card.id} className="service-card">
              <div className="card-tags">
                {card.tags.map((tag, index) => (
                  <span key={index} className="card-tag">
                    {tag}
                  </span>
                ))}
              </div>
              <div className="card-title">{card.title}</div>
              <div className="card-desc">{card.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
